export default __webpack_public_path__ + "static/media/portfolio-136.ca5c793c.jpg";